export default {
  schedulingTypeID: {
    value: null,
    options: [],
    required: true,
    state: null,
    defaultValue: null
  },
  regulationAutoID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null,
    defaultValue: null
  },
  dateScheduling: {
    value: '',
    maxlength: '10',
    required: true,
    state: null,
    defaultValue: ''
  },
  scheduledWith: {
    value: null,
    options: [],
    required: true,
    state: null,
    defaultValue: null
  },
  expertID: {
    value: null,
    clearOption: true,
    options: [],
    required: true,
    state: null,
    defaultValue: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  },
  observations: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/scheduling/sinisterscheduling-form.js